import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const UserPages = {
  list: 'ListUser',
  add: 'AddUser',
  edit: 'EditUser',
  profile: 'UserProfile',
}

const { t } = i18n.global

const title = t('pages.listUser')
const path = '/users'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: UserPages.add,
  component: () => import('@/pages/mainPageWithRoute/user/AddUserPage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: UserPages.edit,
  component: () => import('@/pages/mainPageWithRoute/user/EditUserPage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const Profile: RouteRecordRaw = {
  path: 'profile',
  name: UserPages.profile,
  component: () => import('@/pages/mainPageWithRoute/user/UserProfilePage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true },
}

const List: RouteRecordRaw = {
  path: '',
  name: UserPages.list,
  component: () => import('@/pages/mainPageWithRoute/user/ListUserPage.vue'),
  meta: { title, requiresAuth: true },
}

export const Users: RouteRecordRaw = {
  path,
  name: 'Users',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit, Profile],
}
